const categoryToProductLineMap = {
  SALES_PRODUCTS: 'SALES',
  MARKETING_PRODUCTS: 'MARKETING',
  SERVICE_HUB_PRODUCTS: 'SERVICE',
  CMS_HUB_PRODUCTS: 'CMS',
  OPERATIONS_HUB_PRODUCTS: 'OPERATIONS',
  COMMERCE_PRODUCTS: 'COMMERCE'
};
export const deriveProductLineFromSkuCategory = skuCategoryName => {
  if (!skuCategoryName) return undefined;
  return categoryToProductLineMap[skuCategoryName];
};